import { IServerProps } from 'common/types/common';
import { Layout } from 'layout';
import { GetServerSidePropsContext } from 'next';
import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const LegalContent = dynamic(() =>
  import('modules/legal/LegalContent').then(mod => mod.LegalContent),
);

export const PrivacyPolicyDentelli = () => {
  const { t } = useTranslation('pagePrivacyPolicyOfficium');

  const seo = {
    description: t('pagePrivacyPolicyOfficium:seo.description'),
    image: t('pagePrivacyPolicyOfficium:seo.image'),
    slug: t('pagePrivacyPolicyOfficium:seo.slug'),
    title: t('pagePrivacyPolicyOfficium:seo.title'),
  };
  return (
    <Layout seo={seo}>
      <LegalContent
        title={t('pagePrivacyPolicyOfficium:title')}
        content={t('pagePrivacyPolicyOfficium:content', { returnObjects: true })}
      />
    </Layout>
  );
};

export const getServerSideProps = async (
  context: GetServerSidePropsContext,
): Promise<IServerProps<IPrivacyPolicyDentelliPageProps>> => {
  const locale = await serverSideTranslations(context.locale || 'en', [
    'common',
    'pagePrivacyPolicyOfficium',
  ]);

  return {
    props: {
      data: { referer: context.req.headers.referer || null },
      ...locale,
    },
  };
};

interface IPrivacyPolicyDentelliPageProps {
  data: { referer?: string | null } | Record<string, never>;
}

export default PrivacyPolicyDentelli;
